import { gql } from '@apollo/client'

const createBucketVersionMutation = gql(`
  mutation createBucketVersion($name: String, $bucketId: ID, $module: String, $project: String)
  {
    createBucketVersion(name: $name, bucketId:$bucketId, module:$module, project:$project){
      id
    }
  }
`)

export default createBucketVersionMutation
